var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgP3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.56 35.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e50012;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.56,28.68c0,3.98-3.24,7.22-7.22,7.22H7.23c-3.99,0-7.23-3.24-7.23-7.22V7.23C0,3.24,3.24,0,7.23,0h54.11c3.99,0,7.22,3.24,7.22,7.23v21.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.39,22.46c.14.79.29,1.13.67,1.54.65.67,1.61,1.03,2.77,1.03,1.88,0,3.06-.94,3.06-2.41,0-.99-.48-1.76-1.3-2.07-.55-.19-1.3-.31-2.24-.31s-2.02.05-2.96.14v-4.14c.82.1,1.61.14,2.55.14,2.29,0,3.42-.77,3.42-2.31,0-1.3-.91-2.04-2.5-2.04-1.71,0-2.57.67-2.94,2.21l-5.2-.75c.46-1.49.84-2.21,1.61-3.06,1.47-1.59,3.68-2.41,6.62-2.41,2.62,0,4.79.72,6.16,2.04.89.89,1.35,2.05,1.35,3.42,0,2.55-1.37,4.14-4.14,4.79,1.47.22,2.26.55,3.1,1.28,1.01.91,1.59,2.17,1.59,3.56,0,1.23-.34,2.36-.96,3.2-.53.72-1.37,1.4-2.26,1.8-1.25.58-3.2.94-5,.94-2.17,0-4.33-.51-5.61-1.35-1.11-.72-1.95-1.78-2.48-3.1-.14-.34-.24-.65-.41-1.28l5.1-.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.92,
    y: 4.53,
    width: 26.84,
    height: 26.84,
    rx: 3.4,
    ry: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.85,21.21h-5.32v7.1h-4.54V8.82l9.52.02c2.12,0,3.77.54,4.93,1.63,1.1,1.04,1.65,2.45,1.65,4.25s-.48,3.33-1.43,4.5c-1.1,1.33-2.71,1.99-4.81,1.99M22.12,12.44h-4.59v5.23h4.47c.84,0,1.51-.25,1.99-.75.49-.5.73-1.21.73-2.14,0-1.56-.87-2.33-2.6-2.33"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP3);
export default __webpack_public_path__ + "static/media/p3.84409cbd179cf71000c6b369dbd59e33.svg";
export { ForwardRef as ReactComponent };